import React from 'react';
import { DEFAULT_LANG } from '../../constants';

const LangContext = React.createContext({ lang: DEFAULT_LANG });

export default LangContext;
